/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
/** Input providing a code */
export type CodeInput = {
  /** A non-empty code */
  code: string;
};

export type AcceptCourseCollaborationInviteMutationVariables = Exact<{
  codeInput: Types.CodeInput;
}>;


export type AcceptCourseCollaborationInviteMutation = { acceptCourseCollaborationInvite: { done: boolean } };


export const AcceptCourseCollaborationInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptCourseCollaborationInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codeInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptCourseCollaborationInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codeInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codeInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"done"}}]}}]}}]} as unknown as DocumentNode<AcceptCourseCollaborationInviteMutation, AcceptCourseCollaborationInviteMutationVariables>;